import { useMediaQuery } from "react-responsive"
import cssConfig from "./breakpoints.module.css"

export const useDesktop = () => useMediaQuery({ query: `(min-width: ${cssConfig.desktopMinWidth})` })
